

import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { loginSuccessS } from "../redux/slices/singleFarmSlice";
import { loginSuccessSC } from '../redux/slices/singleCollectorSlice';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { useNavigate } from "react-router-dom";
import {  loginSuccessP } from "../redux/slices/pensSlice";
import { loginSuccessSensor } from "../redux/slices/singleSensorSlice";
import { loginSuccessAllSens } from "../redux/slices/allSensorSlice";
import axios from "axios";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import apiService from "../api/ApiService";
import { isEqual } from "./EditModalDam";
import { version } from "process";
import { Close, Code, CodeOff, Details, LocationOn, ModelTraining } from "@mui/icons-material";
const moment=require('moment-jalaali');


const EditPacket=({penr})=>{
    const {currentCollector}=useSelector(state=>state.singleCollector)
    const [valid,setValid]=useState(false)
    const {openModalls,isOpenModal,closeModalls}=useGlobalContext();
    const mainProp={
        deviceCode:penr?.deviceCode,
        specs:penr?.specs,
        installedLocation:penr?.installedLocation,
        version:penr?.version
      }
    const dispatch=useDispatch();
    const navigate=useNavigate()
    const {watch,
        register,
        handleSubmit,
        formState: { errors }
      } = useForm({defaultValues:mainProp});
   
        const allData=watch()
        useEffect(()=>{setValid(isEqual(mainProp,allData))},[allData])

    const updatePen=async(data)=>{           
                    
                    const res=await apiService.updateCollector(penr?.id,data);
                    dispatch(loginSuccessSC(res.data))
                    openModalls()
                
    }
    

    return <div onClick={closeModalls} className={`modal-overlay ${isOpenModal&&'show-modal'} `}>
        <form onSubmit={handleSubmit(updatePen)} className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <DriveFileRenameOutlineIcon fontSize="large"/>

            <h4 >به روز رسانی کالکتور</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="number"  className='inputSS' placeholder="a" {...register("deviceCode",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Code fontSize='small'/> کد کالکتور</label>
            {errors?.deviceCode?.message&&<span className='errMsg'>{errors.deviceCode.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("specs",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><Details fontSize="small"/> مشخصات کالکتور</label>
            {errors?.specs?.message&&<span className='errMsg'>{errors.specs.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("installedLocation",{required:'این مقدار ضروری است'})}/>
            <label for="" className={'labelSS'}><LocationOn fontSize="small"/>  محل نصب</label>
            {errors?.installedLocation?.message&&<span className='errMsg'>{errors.installedLocation.message}</span>}
        </div>
        <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" {...register("version",{required:'این مقدار ضروری است',pattern:{
                value:/^.{1,50}$/,
                message:'    حداکثر 50 کاراکتر'
            }})}/>
            <label for="" className={'labelSS'}><ModelTraining fontSize="samll"/> ورژن   </label>
            {errors?.version?.message&&<span className='errMsg'>{errors.version.message}</span>}
        </div>
        <button disabled={valid} className="EditMOdalBtnForm" type="submit">
            تایید
        </button>
        
        </form>
        <div style={{marginTop:'220px'}}> 
        
        </div>
        
    </div>
}
export default EditPacket